import React from 'react';
import content from '../../assets/imgs/cachingModalC.png';

const CdnCachingContents = ({ isOpen, onClose, children }) => {
  return (
    <div className={'flex-col'}>
      <div style={{ padding: '0 16px' }}>
        <span
          style={{
            color: '#232323',
            fontFamily: '"Pretendard Variable"',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '140%',
            letterSpacing: '-0.42px',
          }}
        >
          CDN(Content Delivery Network)은 멀티미디어 콘텐츠를 사용자에게
          안정적으로 제공하는 서비스입니다. 콘텐츠를 다수의 ISP에 분산 저장하여,
          사용자에게 가장 빠르게 전달할 수 있는 ISP의 CDN 서버 팜(Server
          Farm)에서 전송합니다. 이를 통해 사용자는 대용량 데이터를 빠르고
          안정적으로 받을 수 있으며, 최적의 네트워크 환경을 제공합니다.
        </span>
      </div>
      <img style={{ width: '100%' }} src={content} alt="" />
    </div>
  );
};
CdnCachingContents.headerTitle = 'CACHING SERVICE';
export default CdnCachingContents;
